import { render, staticRenderFns } from "./epidemic.vue?vue&type=template&id=5f745825&scoped=true"
import script from "./epidemic.vue?vue&type=script&lang=js"
export * from "./epidemic.vue?vue&type=script&lang=js"
import style0 from "./epidemic.vue?vue&type=style&index=0&id=5f745825&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f745825",
  null
  
)

export default component.exports